import { CharComp } from '@/components/CharComp'
import classNames from 'classnames'
import { useKlineStore, useQuoteStore, useStaticTableDataStore, useUserInfoStore } from 'store'
import '../styles/handicap-close-price-layout.scss'

export const HandicapClosePrice = defineComponent({
  setup() {
    const klineStore = useKlineStore()
    const staticTableDataStore = useStaticTableDataStore()
    const userInfoStore = useUserInfoStore()
    const currentKline = computed(() => {
      return klineStore.currentSpotKline
    })

    const quoteStore = useQuoteStore()

    const currencyList = computed(() => {
      return staticTableDataStore.currencyList
    })

    const mark = computed(() => {
      return currencyList.value.find((item) => item.logicName === userInfoStore.currentToCurrency)?.mark || '￥'
    })

    return () => (
      <div class={'handicap-close-price-layout handicap-close-price'}>
        <div
          class={classNames('usdt', {
            up: klineStore.klineDirection === 'up',
            down: klineStore.klineDirection === 'down',
          })}
        >
          <CharComp>{currentKline.value?.close.formatNumberWithCommas().decimalPadZero(klineStore.coinToPrecision) || '--'}</CharComp>
        </div>
        <div class="cny">
          <CharComp>
            ≈{mark.value}
            &nbsp;
            {quoteStore.getLastCurrencyPrice(klineStore.currentSymbolId!)}
          </CharComp>
        </div>
      </div>
    )
  },
})
